import { useEffect } from 'react';

import { PASSCODE_ROUTES } from '../../navigation/paths';

export const useSignedOutOnRestore = (): void => {
  useEffect(() => {
    const onShow = (event: Event): void => {
      if ((event as PageTransitionEvent).persisted && !localStorage.getItem('userId')) {
        window.location.replace(PASSCODE_ROUTES.login);
      }
    };
    window.addEventListener('pageshow', onShow);
    return () => window.removeEventListener('pageshow', onShow);
  }, []);
};
